// test3
(3 && 0);
